module.exports = __webpack_public_path__ + "media/images/av-logo-horizontal-897a40fb9a6c643d1d61d72e8b36ea70.png";